import { PersonalData } from './personal-data';
import { Contacts } from './contacts';

export const ClientWrapper = (props) => {
  const { client, refreshClient } = props;

  return (
    <>
      <PersonalData client={client} refresh={refreshClient} />
      <Contacts client={client} />
    </>
  );
};
